import { type PropsWithChildren } from 'react';

import { TrackAtomProps } from '../types/track.js';

/**
 * The Track atomic slot component
 * @internal
 **/
export const TrackAtom = (props: PropsWithChildren<TrackAtomProps>) => null;

TrackAtom['displayName'] = 'TrackAtom';
